<template>
  <div>
    <el-dialog title="账单详情" :visible="mingxiMark" :close-on-click-modal="false" width="80%" center @close="closeDialog">
      <!--表格1-->
      <div class="chuKuZuoyeWarp-body-table">
         <el-button type="primary"  @click="exportFn()" :disabled="isDisable">导出</el-button>
          <el-table :data="tableList" ref="tabref" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border size="mini" style="width:100%"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
          <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" width="120">
          </el-table-column>
          <el-table-column prop="liquidatedAmountNum" label="结算量" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
           <el-table-column prop="freightPricingTypeName" label="运费计价" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
         <el-table-column prop="" label="运费单价" width="130">
            <template scope="scope">
              <div>
                <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                <span v-if="scope.row.freightPricingType == '1'">
                  <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                  <span v-else>-</span>
                </span>
                <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="freightAmount" label="运费金额(元)" width="140"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="disburseSurcharge" label="支出附加费(元)" width="140"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightAmountTotal" label="运费总额(元)" width="130"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceRate" label="服务费率(%)" width="130"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceCharge" label="服务费(元)" width="140"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightTaxTotal" label="支出总额(元)" width="140">
          </el-table-column>
          <el-table-column prop="yfPaymentAmount" label="已付款金额(元)" width="150">
          </el-table-column>
          <el-table-column prop="yfNoPaymentAmount" label="未付款金额(元)" width="150">
          </el-table-column>
          <el-table-column prop="yfInvoiceAmount" label="已开票金额(元)" width="150">
          </el-table-column>
          <el-table-column prop="yfNoInvoiceAmount" label="未开票金额(元)" width="150">
          </el-table-column>
          <!-- <el-table-column prop="generalCarrier" label="承运方" width="130" :formatter="formatterRowEmpty">
          </el-table-column> -->
          <el-table-column prop="plateNumber" label="车牌号" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverPhone" label="司机电话" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfInvoiceOn" label="发票号" width="200" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column prop="yfSettlementBillNo" label="账单号" width="200" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="180"></el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <!-- <div class="pags" style="text-align: left;">
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { findAmountReceivableInfo } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  components: {
  },
  props: {
    mingxiMark: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      emptyFn: emptyFn,
      xuanzhongArr: [],
      pagesize: 20,
      current: 1,
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['006P00GB001', '006P00GB002'],
      tableList: [],
      isDisable: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    exportFn () {
      exportExcel(
        this.global.tmsPlus + '/customerMonthlySummary/exportAmountReceivable',
        { id: this.rowData.id },
        '应付运单明细'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 获取列表
    getList () {
      this.loading = true
      findAmountReceivableInfo({
        id: this.rowData.id
      }).then(res => {
        this.loading = false
        this.tableList = res
        // this.total = res.total
        // this.map = res.map
      })
    },
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getList()
    },
    closeDialog () {
      this.$emit('update:mingxiMark', false)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
